import ListUsers from './ListUsers';
import User from './User';
import CreateAccount from './CreateAccount';

window.Vue.component('PartnerListUsers', ListUsers);
window.Vue.component('PartnerUser', User);
window.Vue.component('PartnerCreateAccount', CreateAccount);
